import React from "react";
import { Link } from "react-router-dom";
import { Card, Button, Table } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { toast } from "react-semantic-toasts";

import { buildDebugInfo } from "../helpers";

const CommonComponentMiscSettings = ({ user }) => {
    const { currentVersion } = useSelector(({ version }) => ({
        currentVersion: version.current,
    }));
    const debugInfo = buildDebugInfo({ currentVersion, user });

    const copyDebugInfo = () => {
        navigator.clipboard.writeText(debugInfo);
        toast({
            description: `Make sure to paste the info into the email/text along with all details of the issue you're facing.`,
            time: 1000,
            type: "success",
            icon: "checkmark",
            title: "Copied to clipboard",
        });
    };

    const debugInfoBody = [`Debug Info:%0D%0A${debugInfo}`, `Thanks`].join(`%0D%0A%0D%0A`);
    const reportIssueLink = `mailto:txwholesale@totalwine.com?subject=🐛 yDrink Invoice issue report&body=${debugInfoBody}`;

    return (
        <>
            <Card fluid>
                <Card.Content>
                    <Card.Header>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            {" "}
                            {user.name}
                            <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                                <p>v{currentVersion}</p>
                            </div>
                        </div>
                    </Card.Header>
                </Card.Content>
                <Card.Content>
                    <Table basic>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>Email</Table.Cell>
                                <Table.Cell>
                                    <b>{user.email}</b>
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Company ID</Table.Cell>
                                <Table.Cell>
                                    <b>{user.company_id}</b>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Card.Content>
                <Card.Content extra>
                    <Card.Description>
                        If you're noticing any anomalies or not seeing something you expect to see,
                        clear your cached data first and try again.
                        <br />
                        <br />
                        All your local settings and preferences will be reset.
                    </Card.Description>
                    <br />
                    <Button as={Link} to="/cache/clear" color="orange">
                        Clear Cached Data
                    </Button>
                </Card.Content>

                <Card.Content extra>
                    <Card.Description>
                        Still having trouble? Click the button below to copy some critical debugging
                        info for us and send us an email with the details.
                    </Card.Description>
                    <br />
                    <Button onClick={copyDebugInfo}>Copy debug info</Button>
                    <Button as="a" href={reportIssueLink} color="blue" target="_blank">
                        Report Issue
                    </Button>
                </Card.Content>
            </Card>
        </>
    );
};

export default CommonComponentMiscSettings;
